import { FORGOT_PASSWORD, SIGNIN, SIGNUP} from "constants/urls";
import { RouteObject } from "react-router-dom";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // {
  //   index: true,
  //   element: <Navigate to={SIGNIN} />,
  // },
  
  {
    path: SIGNIN,
    lazy: () => import("./pages/authQr-signin"),
  },
  {
    path: SIGNUP,
    lazy: () => import("./pages/authQr-signup"),
  },
  {
    path: FORGOT_PASSWORD,
    lazy: () => import("./pages/forgot-password"),
  },
] as RouteObject[];
